// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:opsz@14..32&family=Montserrat:ital,wght@0,100..900;1,100..900&family=Noto+Sans:ital,wght@0,100..900;1,100..900&family=Unbounded:wght@600&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.heading {
  font-family: "Unbounded", sans-serif;
  font-optical-sizing: auto;
  font-weight: 500;
  font-style: normal;
}

.h1 {
  font-size: 20px;
  line-height: 1.3;
}
@media all and (min-width: 1280px) {
  .h1 {
    font-size: 40px;
    line-height: 1.2;
  }
}

.h2 {
  font-size: 20px;
  line-height: 1.3;
}
@media all and (min-width: 1280px) {
  .h2 {
    font-size: 26px;
    line-height: 1.2;
  }
}

.h3 {
  font-size: 16px;
  line-height: 1.3;
}
@media all and (min-width: 1280px) {
  .h3 {
    font-size: 18px;
    line-height: 1.2;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Heading/Heading.scss"],"names":[],"mappings":"AAGA;EACE,oCAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;AADF;;AAIA;EACE,eAAA;EACA,gBAAA;AADF;AAGE;EAJF;IAKI,eAAA;IACA,gBAAA;EAAF;AACF;;AAGA;EACE,eAAA;EACA,gBAAA;AAAF;AAEE;EAJF;IAKI,eAAA;IACA,gBAAA;EACF;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;AACF;AACE;EAJF;IAKI,eAAA;IACA,gBAAA;EAEF;AACF","sourcesContent":["@import 'src/styles/variables';\n@import url('https://fonts.googleapis.com/css2?family=Inter:opsz@14..32&family=Montserrat:ital,wght@0,100..900;1,100..900&family=Noto+Sans:ital,wght@0,100..900;1,100..900&family=Unbounded:wght@600&display=swap');\n\n.heading {\n  font-family: \"Unbounded\", sans-serif;\n  font-optical-sizing: auto;\n  font-weight: 500;\n  font-style: normal;\n}\n\n.h1 {\n  font-size: 20px;\n  line-height: 1.3;\n\n  @media all and (min-width: $desktop) {\n    font-size: 40px;\n    line-height: 1.2;\n  }\n}\n\n.h2 {\n  font-size: 20px;\n  line-height: 1.3;\n\n  @media all and (min-width: $desktop) {\n    font-size: 26px;\n    line-height: 1.2;\n  }\n}\n\n.h3 {\n  font-size: 16px;\n  line-height: 1.3;\n\n  @media all and (min-width: $desktop) {\n    font-size: 18px;\n    line-height: 1.2;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
